export default __webpack_public_path__ + "static/media/collection-created.7a9adb3f.svg";